const mlsList = [
    {
        integer: 0,
        string: 'Undefined'
    },
    {
        integer: 1,
        string: 'SFAR'
    },
    {
        integer: 2,
        string: 'SDAR'
    },
    {
        integer: 3,
        string: 'Miami'
    },
    {
        integer: 5,
        string: 'EBRD'
    },
    {
        integer: 6,
        string: 'RIAR'
    },
    {
        integer: 7,
        string: 'CCAR'
    },
    {
        integer: 8,
        string: 'BayEast'
    },
    {
        integer: 9,
        string: 'BAREIS'
    }
];

export default mlsList;
